import React from 'react';

export const Edit = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.7855 8.73285C17.1964 8.79155 16.6299 9.07889 16.2182 9.58173L8.20532 19.3678L8.18767 19.5472L7.88047 22.704L7.82935 23.1653C7.80942 23.3452 7.98138 23.486 8.15384 23.431L8.59605 23.2899L11.6302 22.3659L11.8026 22.3132L19.8155 12.5272C20.6389 11.5215 20.4952 10.0793 19.4896 9.25583C18.9867 8.8441 18.3747 8.67415 17.7855 8.73285ZM17.8924 9.80571C18.176 9.77746 18.4748 9.8787 18.7769 10.1261C19.3789 10.619 19.438 11.2126 18.9452 11.8146L18.5792 12.2418L16.7419 10.7374L17.0885 10.2943C17.3359 9.99215 17.6088 9.83396 17.8924 9.80571ZM16.0293 11.6077L17.8666 13.1121L11.7381 20.5967C11.297 19.9124 10.6587 19.3898 9.90083 19.0923L16.0293 11.6077ZM9.27084 20.0787C9.97294 20.2841 10.5556 20.7611 10.8954 21.4089L9.08547 21.9622L9.27084 20.0787Z"
                fill="#F5F5F5"
            />
            <path
                d="M13.5 22.875C13.5 22.5298 13.7798 22.25 14.125 22.25H22.875C23.2202 22.25 23.5 22.5298 23.5 22.875C23.5 23.2202 23.2202 23.5 22.875 23.5H14.125C13.7798 23.5 13.5 23.2202 13.5 22.875Z"
                fill="#818998"
            />
        </svg>
    );
};
